import script from "./TableValidasi.vue?vue&type=script&setup=true&lang=js"
export * from "./TableValidasi.vue?vue&type=script&setup=true&lang=js"

import "./TableValidasi.vue?vue&type=style&index=0&id=0fe3b3bf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0fe3b3bf"]])

export default __exports__